module.exports = "/_next/static/media/84501a2d71a7028c57cdc41c6e3de922.svg";